import styled from 'styled-components';
import React from 'react';
import { SelectField, IconButton, Text, TextButton, SearchField, Headline, ToggleSwitch, } from '@oneaudi/unified-web-components';
import { SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK, SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_DARK, SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK, SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_DARK, SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK, SYS_BORDER_RADIUS_MD, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_FONT_SIZES_RELATIVE_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_MD, SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL, } from '@oneaudi/unified-web-common';
import { SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DEFAULT_DARK, SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_DARK, SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK, SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DISABLED_DARK, SEM_COLOR_FORMS_SURFACE_FIELD_FILL_INTERACTIVE_DARK, SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DISABLED_DARK, SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK, SYS_COLOR_TEXT_COPY_DEFAULT_DARK, SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK, SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK, SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DEFAULT_DARK, SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK, } from '@oneaudi/unified-web-alpha-common';
import { dynamicStyling, dynamicStylingHelper } from '../../utils';
export const MasOverlayContainer = styled.div `
  display: flex;
  flex-flow: column;
  position: relative;
`;
export const MasOverlayCloseButtonWrapper = styled.div `
  display: flex;
  position: absolute;
  top: -25px;
  right: -25px;
  z-index: 1;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    top: -55px;
    right: -55px;
  }
`;
export const MasOverlayCloseButton = styled((props) => (React.createElement(IconButton, Object.assign({}, props)))) ``;
export const MasOverlayHeadlineWrapper = styled.div `
  width: 100%;
  padding-inline-end: ${SYS_SPACE_FIXED_450};
  ${dynamicStylingHelper(`padding-block-end: ${SYS_SPACE_FIXED_200}`, `padding-block-end: ${SYS_SPACE_FIXED_450};`)};
`;
export const ConsentRequestWrapper = styled.div `
  padding-block-end: ${SYS_SPACE_FIXED_200};
`;
export const LocationInputWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
  padding-block-end: ${SYS_SPACE_FIXED_450};
  ${dynamicStylingHelper('', `gap: ${SYS_SPACE_FIXED_200};`)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: 57px;
    margin-top: unset;
  }
`;
export const SearchWrapper = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  gmp-place-autocomplete {
    padding: 0;
  }
`;
export const SearchStyle = styled.div `
  align-content: end;
  width: 100%;
`;
export const StyledToggleSwitch = styled((props) => React.createElement(ToggleSwitch, Object.assign({}, props))) `
  padding-top: ${SYS_SPACE_FIXED_200};
`;
export const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  padding-bottom: ${SYS_SPACE_FIXED_200};
  ${dynamicStylingHelper('', `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};`)};
`;
export const StyledSearchField = styled((props) => React.createElement(SearchField, Object.assign({}, props))) `
  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    min-width: unset;
  }
  div:has(> button) {
    z-index: 1;
  }
  div button,
  svg {
    ${dynamicStyling({
    alpha: `color: rgba(252, 252, 253, 0.7);`,
})}
  }
  div button:disabled {
    > svg {
      ${dynamicStyling({
    alpha: `color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK};`,
})}
    }
  }
  input:not(:disabled) {
    ${dynamicStyling({
    alpha: `
    background: ${SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK};
    box-shadow: ${SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK} 0 0 0 1px;
    color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DEFAULT_DARK};
  `,
})};
    &:hover,
    &:focus {
      ${dynamicStyling({
    alpha: `
        background: ${SEM_COLOR_FORMS_SURFACE_FIELD_FILL_INTERACTIVE_DARK};
        box-shadow: ${SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK} 0 0 0 1px;
        `,
})}
    }
    &::placeholder {
      ${dynamicStyling({
    alpha: `
      color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_DARK};
    `,
})};
    }
  }
`;
export const StyledText = styled(Text) `
  ${dynamicStylingHelper('', `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};`)};
`;
export const LocateMeButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) ``;
export const StyledRadiusSelect = styled((props) => React.createElement(SelectField, Object.assign({}, props))) `
  margin-top: ${SYS_SPACE_FIXED_300};
  width: 100%;
  label:has(+ div select:disabled),
  label {
    background: none;
  }
  div select:disabled {
    ${dynamicStyling({
    alpha: `
        color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK};
      `,
})}
    background: ${SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DISABLED_DARK};
    border: ${SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DISABLED_DARK};
  }
  label:has(+ div select:not(:disabled)),
  label  {
    ${dynamicStyling({
    alpha: `
        color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DEFAULT_DARK};
      `,
})}
  }
  select:not(:disabled) {
    ${dynamicStyling({
    alpha: `
    background: ${SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK};
    box-shadow: ${SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK} 0 0 0 1px;
    color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DEFAULT_DARK};
  `,
})};
    &:hover,
    &:focus {
      ${dynamicStyling({
    alpha: `
        background: ${SEM_COLOR_FORMS_SURFACE_FIELD_FILL_INTERACTIVE_DARK};
        box-shadow: ${SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK} 0 0 0 1px;
        `,
})}
    }
    &::placeholder {
      ${dynamicStyling({
    alpha: `
      color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_DARK};
    `,
})};
    }
  label + div select::placeholder {
    ${dynamicStyling({
    alpha: `
        color: ${SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_DARK};
      `,
})};
  }
  
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-top: unset;
    padding-inline-start: ${SYS_SPACE_FIXED_300};
  }
`;
export const StyledResultsButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  width: auto;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: fit-content;
  }
  display: flex;
  justify-content: center;
  ${dynamicStyling({
    alpha: `
    background: ${SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK};
    color: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK};
  `,
})}

  &:disabled {
    box-shadow: none;
    ${dynamicStyling({
    alpha: `
      
        background: ${SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_DARK};
        color: ${SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_DARK}
    `,
})}
  }
`;
export const CookieConsentWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: ${dynamicStylingHelper(SYS_SPACE_RELATIVE_MD, SYS_SPACE_FIXED_200)};
  margin-bottom: ${SYS_SPACE_FIXED_450};
  gap: 16px;
  color: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
  background-color: hsla(33, 0%, 0%, 0.05);
  height: fit-content;
  box-sizing: border-box;
  border-radius: ${dynamicStylingHelper('0', '20px')};

  svg {
    flex: 1 0 24px;
  }

  a {
    font-weight: bold;
    border-bottom: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
    color: inherit;
  }
`;
export const CloseButtonWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: var(--colors-background-level-1-611444a);
  z-index: 100;
`;
export const StyledCloseButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  position: fixed;
  right: 0;
  top: 0;
`;
export const autocompleteCSS = `
    .pac-container {
      background-color: #ffffff;
      padding-block: 24px 24px;
      padding-inline: 16px 16px;
      z-index: 10000;
      position: fixed !important;
    }

    .pac-icon {
      display: none;
    }
   .pac-item,.pac-item-query, .pac-matched {
      color: '#333333';
      font-size: 16px;
      font-family: AudiType,sans-serif;
      font-stretch: 105%;
      line-height: 24px;
      font-weight: 400;
      border-top: none;
    }
    .pac-item{
      padding: 0px;
    }
     .pac-item:not(:last-child) {
      border-block-end: 1px solid #d9d9d9;
      padding-block-end: 10px; 
    }
    .pac-item:not(:first-child) {
      padding-block-start: 10px; 
    }
    .pac-item:hover, .pac-item-selected, .pac-item-selected:hover{
      background-color: '#f2f2f2';
      padding-inline-start: 8px;
      cursor: pointer;
    }
    .pac-item:hover span, .pac-item-selected:hover span, .pac-item-selected span{
      color: '#000000';
    }
    .marker-with-counter{
      margin-top: -6px;
    }
  `;
export const autocompleteCSSAlpha = `
.pac-container {
  background: ${SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK};
  color: ${SYS_COLOR_TEXT_COPY_DEFAULT_DARK};
  padding: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200};
  border-radius: ${SYS_BORDER_RADIUS_MD};
  margin-top:${SYS_SPACE_FIXED_150};
  border: none;
  z-index: 10000;
  position: fixed !important;
}

.pac-icon {
  display: none;
}

.pac-item,
.pac-item-query,
.pac-matched {
   color: ${SYS_COLOR_TEXT_COPY_DEFAULT_DARK};
    font-size: ${SYS_FONT_SIZES_RELATIVE_100};
    font-family: ${SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL};
    font-stretch: 105%;
    line-height: 24px;
    font-weight: 400;
}

.pac-item {
  padding: ${SYS_SPACE_FIXED_150} 0 ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_150};
  border-top: none;
}

.pac-item:not(:last-child) {
  border-block-end: 1px solid ${SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK};
}

.pac-item:hover,
.pac-item-selected,
.pac-item-selected:hover {
  background: none;
  cursor: pointer;
}

.pac-item:hover span,
.pac-item-selected span,
.pac-item-selected:hover span {
  color: #000000;
}
.pac-logo:after {
  display: none;
}
`;
